
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDelete as ObiDeleteElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-delete.js';
 
 
 

 
 export const ObiDelete = createComponent({
   react: React,
   tagName: 'obi-delete',
   elementClass: ObiDeleteElement,
   events: {
     
   }
  });
 
 